import React from 'react';

export default function UserMapping(){
    return(
        <div className="app__grid card dummy_background" style={{ olor:"#199b8b"}}>
            <h2>User Mapping page under construction</h2>
        </div>
    )
}